import React from 'react';
import { CustomTextField } from '../../../../widgets/CustomTextField';
import { EntityForm } from '../../../../widgets/Forms';
import ViewUtils from '../../../../ViewUtils';
import TabPanel from '../../../../widgets/TabPanel';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import OFOSearch from '../../Controls/OFOSearch';
import { LookupField } from '../../../../widgets/LookupField';
import Table from '@material-ui/core/Table';
import { SelectItem } from '../../../../widgets/SelectItem';
import { CustomDatePicker } from '../../../../widgets/CustomDatePicker';
import CheckboxGroup from 'antd/lib/checkbox/Group';
import { CustomCheckbox } from '../../../../widgets/CustomCheckbox';

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const utils = new ViewUtils();

const styles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            minWidth: 50,
            textAlign: 'center',
        },
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 200,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
        minWidth: 200
    },
    inputForm: {
        minWidth: '200px',
    },
    table: {
        minWidth: 700,
    },
    inputCenter: {
        textAlign: 'center'
    },
    paper: {
        position: "absolute",
        width: 600,
        height: 450,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(0.1)
    }
}));

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: '#01579B',
        color: theme.palette.common.white,
        border: '1px solid white',
        height: 6
    },
    body: {
        fontSize: 11,
    },

}))(TableCell);

const StyledTableTextCell = withStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            // width: 50,
            textAlign: 'center'
        },
    },
    body: {
        fontSize: 14,
        fontWeight: 500
    }

}))(TableCell);


const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
            height: theme.palette.action.main
        },
    },
}))(TableRow);

const useStyles = theme => ({
    table: {
        minWidth: 700,
    },
});

//const checkboxList = this.props.checkboxList;

function rand() {
    return Math.round(Math.random() * 20) - 10;
}

function getModalStyle() {
    const top = 5;
    const left = 5;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`
    };
}


export const HardToFillVacanciesForm = React.forwardRef((props, ref) => {
    const [tabValue, setTabValue] = React.useState(0);
    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const [otherTextFieldVisible, setOtherTextFieldVisible] = React.useState(false);

    const handleMainReasonsChange = (id, form) => event => {

        if (id === "7") {
            setOtherTextFieldVisible(event.target.checked)
        }

        form.updateValue("HardToFillVacancyReasonID" + id , event.target.checked);
    }

    function checkValue(value) {

        if (value !== undefined && value !== null) {
            if (value.Description === "Other") {
                return false
            }
            else {
                return true
            }
        } else {
            return true
        }
    }

    return (
        <EntityForm
            ref={ref}
            viewId={null}
            values={props.data}
            entityLookupController={props.entityLookupController}
            org="saseta"
            entityLookupId={props.id}
            useCustomSettings={false}
            dataArrivedHandler={props.dataArrivedHandler} valueChangeHandler={props.valueChangeHandler}>
            {form =>
                <form className={form.classes.container} id="WSPATRForm">
                    <div className="row w-100">
                        <div className="col w-100">
                            <TabPanel value={tabValue} index={0} className=''>
                                <table cellPadding="2" width="80%">
                                    <tbody>
                                        <tr>
                                            <td width="80%">
                                                <LookupField
                                                    id="OFOOccupationID"
                                                    required
                                                    label="OFO Occupation"
                                                    className="w-100"
                                                    form={form}
                                                >
                                                    <OFOSearch showTitle={true} mode='lookup' dataUrl="api/sims/WSPATRForms2024/GetWSPATRFormOFOCodeSearchATR"
                                                        onLookupValueChange={(value) => {
                                                            form.setLookupSelection("OFOOccupationID", value)
                                                        }} autoFetchData={false} selection={props.selection}
                                                        WSPATRID={props.WSPATRID} />
                                                </LookupField>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td width="80%"><br/>
                                                <p style={{fontWeight:"bold"}}>Identify the main reasons why the listed occupations were HARD-TO-FILL VACANCIES</p>
                                                {props.MainReasons.map((item) => (
                                                    <CustomCheckbox
                                                        id={"HardToFillVacancyReasonID" + item.Id}
                                                        key={tabValue}
                                                        form={form}
                                                        onChange={handleMainReasonsChange.bind(this, item.Id)}
                                                        inputProps={{
                                                            'aria-label': 'primary checkbox',
                                                        }}
                                                        label={item.Description}
                                                        //checked={get}
                                                    />
                                                ))} <br />
                                                <CustomTextField
                                                    id="HardToFillVacancyReason"
                                                    key={tabValue}
                                                    parentId={0}
                                                    label="Hard To Fill Vacancy Reason Other"
                                                    className="w-100"
                                                    hidden={!otherTextFieldVisible}
                                                    form={form}
                                                    />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td width="80%">
                                                <CustomTextField
                                                    id="NoOfVacancies"
                                                    key={tabValue}
                                                    parentId={0}
                                                    label="Number of HARD-TO-FILL VACANCIES"
                                                    className="w-100"
                                                    form={form}
                                                    required
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td width="80%">
                                                <SelectItem
                                                    dataUrl={"api/sims/WSPATRForms2024/GetLookupList?listId=Province"}
                                                    id="ProvinceID"
                                                    name="ProvinceID"
                                                    label="Region"
                                                    className="w-100"
                                                    allowEmptyValue={true}
                                                    required
                                                    form={form} />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td width="80%">
                                                <SelectItem
                                                    dataUrl={"api/sims/WSPATRForms2024/GetLookupList?listId=WSPATRDigitalSkills"}
                                                    id="WSPATRDigitalSkillsID"
                                                    name="WSPATRDigitalSkillsID"
                                                    label="Please indicated the emerging digital skills required in your company/organization"
                                                    className="w-100"
                                                    allowEmptyValue={true}
                                                    required
                                                    form={form} /> <br />
                                                <CustomTextField
                                                    id="OtherDigitalSkills"
                                                    key={tabValue}
                                                    parentId={0}
                                                    label="Other Digital Skills"
                                                    className="w-100"
                                                    hidden={checkValue(form.values["WSPATRDigitalSkillsID"])}
                                                    form={form}
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                            </TabPanel>
                        </div>
                    </div>
                </form >
            }
        </EntityForm >
    );
})